// Library Imports
import React, { useCallback, useContext } from 'react'
import { Card } from 'react-bootstrap'
import { Link } from 'react-router-dom'
// Asset Imports
import '../../assets/css/stylesheets/components/card/CategoryCard.css'
// Contect Imports
import { DirectoryContext } from '../../contexts/DirectoryContext'

function CategoryCard({ key, categoryName, recordCount, icon, id }) {
    const {
        setInputCategory
    } = useContext(DirectoryContext)

    const handleCategoryChanged = useCallback((e) => {
        setInputCategory(id);
    })

    return (
        <Card key={key} className='categorycard'>
            <Card.Title className='categorycard-title'>
                {categoryName}
            </Card.Title>
            <Card.Body className='categorycard-body'>
                <Card.Text className='categorycard-text'>
                    ({recordCount})
                </Card.Text>
            </Card.Body>
            <Link className='categorycard-link' onClick={handleCategoryChanged} to="/listings">
                {icon}
            </Link>
        </Card>
    )
}

export default CategoryCard